import { store } from 'STORE';
import defaults from 'DEFAULTS';
import notification from '@helps/notification';
import merge from 'deepmerge';

const configs = merge(require('ROOT/configs.json'), require('ROOT/configs.prod.json'), {
  arrayMerge: (target, source) => [...new Set([...target, ...source])],
});

const HOST = localStorage.getItem('services') || configs.href.host;
const HOST_MAGMA = configs.href.hostMagma;
const PROTOCOL = localStorage.getItem('protocol') || configs.href.protocol;
const PATH = `${PROTOCOL}://${HOST}/api/v1`;
const PATH_MAGMA = `${PROTOCOL}://${HOST_MAGMA}/api/${defaults.translation.lang}/v1`;
const PATH_USERS = `${PATH}`;
const MAGMA = `${PATH_MAGMA}`;
const MAGMA_USERS = `${PATH_MAGMA}/users`;

// Функция для определения нужно ли использовать magmaToken
const shouldUseMagmaToken = (url) => {
  // Проверяем, что URL содержит MAGMA базовый путь
  if (!url.includes(MAGMA)) {
    return false;
  }

  return true;

  // // Определяем, нужен ли magmaToken только для profile эндпоинтов
  // const profilePaths = [
  //   '/profile',
  //   '/director',
  //   '/staff',
  //   '/shareholder',
  //   '/operational',
  //   '/partner',
  //   '/business-activity',
  //   '/status-certification',
  //   '/verification',
  //   '/password/change',
  //   '/phone/change-request',
  //   '/email/change',
  //   '/passphrase',
  //   '/specific-roles',
  //   '/profile/update-actual-address',
  //   '/profile/confirm',
  //   '/profile/success',
  //   '/profile/progress',
  //   '/verification/progress',
  // ];
  //
  // return profilePaths.some((path) => url.includes(path));
};

// Модифицированная функция для получения токена
const getAuthInfo = (type, useMagmaToken = false) => {
  const state = store.getState();

  if (useMagmaToken) {
    // console.log(sessionStorage.getItem('magma-token'));
    return sessionStorage.getItem('magma-token'); // // Для MAGMA эндпоинтов используем magmaToken если он есть
    // if (state.magmaToken && state.magmaToken[type]) {
    //   return state.magmaToken[type];
    // }
    // // Fallback на обычный токен если magmaToken не установлен
    // if (store.getState().userToken[type]) {
    //   return store.getState().userToken[type];
    // }
    // return null;
  }

  // Для обычных запросов используем userToken
  return store.getState().userToken[type];
};

const getDashboardRoute = () => `${PATH}/${getAuthInfo('tokenType', false)}/dashboard`;

const getById = (id) => (id ? `/${id}` : '');

if (
  localStorage.getItem('services') ||
  localStorage.getItem('protocol') ||
  (defaults.isLocalhost && sessionStorage.getItem('devMode') == 1)
) {
  notification({ message: 'You are the god of the monkeys!' }, 'warn');
}

String.prototype.AXIOS = function (method = '', data, upload_callback) {
  const url = this.trim();

  // Определяем, нужен ли magmaToken
  const useMagmaToken = shouldUseMagmaToken(url);

  // Для отладки (можно убрать в production)
  if (useMagmaToken && defaults.isLocalhost) {
    // console.log('[API] Using magmaToken for URL:', url);
  }

  const CONFIG = {
    method: method.trim().toLowerCase(),
    url: url,
    headers: {
      ...(getAuthInfo('token', useMagmaToken)
        ? {
            Authorization: `Bearer ${getAuthInfo('token', useMagmaToken)}`,
          }
        : {}),
      'Content-Type': upload_callback ? 'multipart/form-data' : 'application/json',
      'Access-Control-Allow-Origin': '*',
      'X-Client-Version': configs.meta.tag || 'null',
    },
  };

  if (defaults.isLocalhost && sessionStorage.getItem('devMode') == 1) {
    CONFIG.headers.devMode = 1;
  }

  if (data) {
    if (['post', 'put', 'patch', 'delete'].indexOf(CONFIG.method) >= 0) {
      CONFIG.data = data;
    }

    if (CONFIG.method === 'get') {
      CONFIG.params = data;
    }
  }

  if (upload_callback) {
    CONFIG.onUploadProgress = (progressEvent) => {
      upload_callback(progressEvent);
    };
  }

  return CONFIG;
};

String.prototype.AXIOS_STREAM = function (data, customHeaders = {}) {
  const url = this.trim();

  // Определяем, нужен ли magmaToken
  const useMagmaToken = shouldUseMagmaToken(url);

  const CONFIG = {
    method: 'get',
    url: url,
    responseType: 'blob',
    headers: {
      ...(getAuthInfo('token', useMagmaToken)
        ? {
            Authorization: `Bearer ${getAuthInfo('token', useMagmaToken)}`,
          }
        : {}),
      'Access-Control-Allow-Origin': '*',
      ...customHeaders,
    },
  };

  if (data) {
    CONFIG.params = data;
  }

  return CONFIG;
};

export default {
  url: (url) => url,
  additional: {
    early_access: `${PATH}/early-access`,
  },
  system: {
    logs: `${PATH}/log/requests/`,
    country: `${PATH}/country/`,
    version: `${PROTOCOL}://${HOST}`,
  },
  users: {
    rates: () => `${PATH}/exchange/get-currency`,
    referralSources: `${PATH_USERS}/register/referral-sources`,
    wallets: () => `${PATH_USERS}/exchange/get-wallets`,
    exchange: () => `${PATH_USERS}/exchange`,
    confirmExchange: () => `${PATH_USERS}/exchange/complete`,
    transfer: () => `${PATH_USERS}/transfer`,
    userInfo: () => `${PATH_USERS}/me`,

    history: (type) => `${PATH_USERS}/${type}/loginhistory`,
    navigationMenu: (type) => `${PATH_USERS}/${type}/navigation`,
    password_reset_request: () => `${PATH_USERS}/reset-password/send`,
    password_reset: () => `${PATH_USERS}/reset-password`,
    spaces: () => `${PATH_USERS}/spaces`,
    dashboardBalances: () => `${PATH_USERS}/dashboard`,
    permissions: (id = '', userType = 'aemi') => `${PATH}/users/${userType}${getById(id)}/permissions`,
    roles: (id = '', role_id = '', userType = 'aemi') =>
      `${PATH}/users/${userType}${getById(id)}/roles${getById(role_id)}`,
    bank_institutions: (id = '', userType = 'aemi') => `${PATH}/users/${userType}/bank-institutions${getById(id)}`,
    registration: {
      user_status: () => `${PATH_USERS}/register/get-user-status`,
      changeRiskLevel: () => `${PATH_USERS}/spaces/change-risk-level`,
      register_new_user: () => `${PATH_USERS}/register`,
      verify_email: () => `${PATH_USERS}/verify-email`,
      verify_email_resend: () => `${PATH_USERS}/verify-email/send`,
      checkSpaces: () => `${PATH_USERS}/spaces/check`,
      spacesRegister: () => `${PATH_USERS}/spaces/register`,
      email: (type, step) => `${PATH_USERS}/${type}/verification/email/step${step}`,
      phone: (type, step) => `${PATH_USERS}/${type}/verification/phone/step${step}`,
      resend: (type, item) => `${PATH_USERS}/${type}/verification/${item}/code-resend`,
      password: (type) => `${PATH_USERS}/register/set-password`,
      google_auth_step_1: (type) => `${PATH_USERS}/${type}/verification/tfa/google-auth/step1`,
      google_auth_step_2: (type) => `${PATH_USERS}/${type}/verification/tfa/google-auth/step2`,
    },
    dataForRegistration: {
      client: {
        business_sectors: (type) => `${MAGMA_USERS}/${type}/business-sectors`,
        business_types: (type, value) => `${MAGMA_USERS}/${type}/business-types${getById(value)}`,
        annual_turnover: (type, sortBy = 'created_at') => `${PATH_USERS}/${type}/annual-turnover?sort=${sortBy}`,
        total_net_worth: (type, sortBy = 'created_at') => `${PATH_USERS}/${type}/total-net-worth?sort=${sortBy}`,
        annual_income: (type, sortBy = 'created_at') => `${PATH_USERS}/${type}/annual-income?sort=${sortBy}`,
        agreements: (type, sortBy = 'order') => `${PATH_USERS}/${type}/agreements?sort=${sortBy}`,
      },
      aemi: {
        business_sectors: (type) => `${PATH}/aemi/dashboard/customers/${type}/business-sectors`,
        send_kyc_forms: (id) => `${PATH}/aemi/dashboard/customers/${id}/send-kyc-forms`,
        business_types: (type, value) => `${PATH}/aemi/dashboard/customers/${type}/business-types${getById(value)}`,
        annual_turnover: (type, sortBy = 'created_at') =>
          `${PATH}/aemi/dashboard/customers/${type}/annual-turnover?sort=${sortBy}`,
        total_net_worth: (type, sortBy = 'created_at') =>
          `${PATH}/aemi/dashboard/customers/${type}/total-net-worth?sort=${sortBy}`,
        annual_income: (type, sortBy = 'created_at') =>
          `${PATH}/aemi/dashboard/customers/${type}/annual-income?sort=${sortBy}`,
        agreements: (type, id, sortBy = 'order') =>
          `${PATH}/aemi/dashboard/customers/${type}/agreements${getById(id)}?sort=${sortBy}`,
      },
    },
    authorization: {
      login: () => `${PATH_USERS}/login`,
      loginByOauth: (space) => `${PATH_USERS}/oauth/${space}`,
      session: () => `${PATH_USERS}/session`,
      renew_token: (type) => `${PATH_USERS}/${type}/renew-token/`,
    },
    profile: {
      profile: (type) => `${MAGMA_USERS}/${type}/profile`,
      personal: (type, id = '') => `${MAGMA_USERS}/${type}/profile/personal${getById(id)}`,
      business: (type, id = '') => `${MAGMA_USERS}/${type}/profile/business${getById(id)}`,
      address: (type, id = '') => `${MAGMA_USERS}/${type}/profile/address${getById(id)}`,
      director: (type, id = '') => `${MAGMA_USERS}/${type}/director${getById(id)}`,
      staff: (type, id = '') => `${MAGMA_USERS}/${type}/staff${getById(id)}`,
      shareholder: (userType, shareholderType, id = '') =>
        `${MAGMA_USERS}/${userType}/shareholder/${shareholderType}${getById(id)}`,
      ubo: (userType, shareholderType, id = '') => `${MAGMA_USERS}/${userType}/shareholder/ubo${getById(id)}`,
      operational: (type, id = '') => `${MAGMA_USERS}/${type}/profile/operational${getById(id)}`,
      otherStake: (type, id = '') => `${MAGMA_USERS}/${type}/shareholder/other-ownership-stakes`,
      partner: (type, id = '') => `${MAGMA_USERS}/${type}/partner${getById(id)}`,
      businessActivity: (type, id = '') => `${MAGMA_USERS}/${type}/profile/business-activity${getById(id)}`,
      statusCertification: (type, id = '') => `${MAGMA_USERS}/${type}/profile/status-certification${getById(id)}`,
      verification: (type) => `${MAGMA_USERS}/${type}/verification`,
      verificationProgress: (type) => `${MAGMA_USERS}/${type}/verification/progress`,
      confirm: (type) => `${MAGMA_USERS}/${type}/profile/confirm`,
      success: (type, id = '') => `${MAGMA_USERS}/${type}/profile/success${getById(id)}`,
      progress: (type) => `${MAGMA_USERS}/${type}/profile/progress`,
      request: (type, target, action) => `${MAGMA_USERS}/${type}/verification/${target}/${action}`,
      changePassword: (type) => `${MAGMA_USERS}/${type}/password/change`,
      changeActualAddress: (type) => `${MAGMA_USERS}/${type}/profile/update-actual-address`,
      changePhoneRequest: (type) => `${MAGMA_USERS}/${type}/phone/change-request`,
      changePhoneVerify: (type) => `${MAGMA_USERS}/${type}/phone/change-request/verify`,
      changeEmailRequest: (type) => `${MAGMA_USERS}/${type}/email/change/request`,
      changeEmailVerify: (type) => `${MAGMA_USERS}/${type}/email/change/verify`,
      passphrase: (type) => `${MAGMA_USERS}/${type}/profile/passphrase`,
      roles: () => `${MAGMA_USERS}/specific-roles/users-company-api`,
      // ===== Document Review (Customer Document Review) =====
      documentReview: {
        // 01 - Get onboarding review
        onboarding: (type) => `${MAGMA}/customer-document-review/company/onboarding`,

        // 02 - Upload registration temporary document
        uploadTemp: (type) => `${MAGMA}/filemanager/documents/registration/temp`,

        // 03 - Attach temporary document to requirement
        attachDocument: (type, requirementId) =>
          `${MAGMA}/customer-document-review/company/requirements/${requirementId}/documents`,

        // 04 - Delete review document
        deleteDocument: (type, documentId) => `${MAGMA}/customer-document-review/company/documents/${documentId}`,

        // 05 - Submit onboarding review
        submitOnboarding: (type) => `${MAGMA}/customer-document-review/company/onboarding/submit`,

        downloadDocument: (type, documentId) => `${MAGMA}/filemanager/documents/company/download/${documentId}`,

        messages: (id) => `${MAGMA}/case-management/messages${getById(id)}`,
        messagesInfo: (id) => `${MAGMA}/case-management/messages-info${getById(id)}`,
        message: () => `${MAGMA}/case-management/message`,
        changeStatus: (id) => `${MAGMA}/case-management/change-status${getById(id)}`,
        unreadMessages: () => `${MAGMA}/case-management/new-messages`,
        messageDocuments: (type, id = '') => `${MAGMA}/filemanager/documents/information-request/${type}${getById(id)}`,
      },
    },
  },
  modals: {
    aemi: {
      modals: `${PATH}/information-request/information-popups`,
      modal: () => `${PATH}/information-request/information-popups`,
      editModal: (id) => `${PATH}/information-request/information-popups/${id}`,
      downloadModalLogs: (id) => `${PATH}/information-request/information-popups/${id}/download-responses`,
      editFileDocument: (id) => `${PATH}/information-request/information-popups/attachments/${id}`,
      users: (id) => `${PATH}/information-request/information-popups/users${getById(id)}`,
      usersNotPaginated: `${PATH}/information-request/information-popups/users/not-paginated`,
    },
    confirm: (id) => `${PATH}/information-request/information-popups/confirm/${id}`,
    list: (userType) => `${PATH}/users/${userType}/information-popups`,
  },
  tfa: {
    googleQrCode: () => `${PATH_USERS}/2fa/secret`,
    phoneCode: () => `${PATH_USERS}/security/tfa/phone/send_code`,
    addPhone: (type) => `${PATH_USERS}/${type}/security/tfa/add-phone`,
    resendPhone: (type) => `${PATH_USERS}/${type}/security/tfa/add-phone/resend`,
    verifySms: (type) => `${PATH_USERS}/${type}/security/tfa/add-phone`,
    bindGoogleTfa: () => `${PATH_USERS}/2fa/attach`,
    unbindGoogleTfa: () => `${PATH_USERS}/security/tfa/google/unbind`,
    bindPhoneTfa: () => `${PATH_USERS}/security/tfa/phone/bind`,
    unbindPhoneTfa: () => `${PATH_USERS}/security/tfa/phone/unbind`,
    preferred: (type) => `${PATH_USERS}/${type}/settings/security/tfa/preferred`,
    // for auth
    googleAuthQrCode: (type) => `${PATH_USERS}/${type}/get_qr`,
    checkGoogleAuthTfa: (type) => `${PATH_USERS}/${type}/check_qr`, //
    checkGoogleAuthTfa2: (type) => `${MAGMA_USERS}/${type}/check_qr`, //
    phoneAuthCode: (type) => `${PATH_USERS}/${type}/send_sms_code`,
    checkPhoneAuthTfa: (type) => `${PATH_USERS}/${type}/check_sms_code`,
  },
  communication: {
    client: {
      requests: (id) => `${PATH}/case-management/requests${getById(id)}`,
      messages: (id) => `${PATH}/case-management/messages${getById(id)}`,
      messagesInfo: (id) => `${PATH}/case-management/messages-info${getById(id)}`,
      message: () => `${PATH}/case-management/message`,
      changeStatus: (id) => `${PATH}/case-management/change-status${getById(id)}`,
      unreadMessages: () => `${PATH}/case-management/new-messages`,
    },
    aemi: {
      changeAccessStatus: (id) => `${PATH}/aemi/dashboard/customers${getById(id)}/phone-tfa-access`,
      staff: (id) => `${PATH}/aemi/dashboard/customers${getById(id)}/staff`,
      reports: `${PATH}/aemi/dashboard/reports/reconciliation-statements`,
      reports_payment_calendar: `${PATH}/aemi/dashboard/reports/payment-calendar`,
      managers: `${PATH}/aemi/dashboard/customers/management/active-managers`,
      assignToManager: `${PATH}/aemi/dashboard/customers/management/assign-to-customer`,
      assignToManagers: `${PATH}/aemi/dashboard/customers/management/sync-secondary-managers`,
      assignToWallet: `${PATH}/aemi/dashboard/customers/management/assign-to-wallet`,
      assignToMarket: `${PATH}/aemi/dashboard/markets/assign-to-customer`,
      assignToCustomerGroup: `${PATH}/aemi/dashboard/customer-groups/assign-to-customer`,
      referenceType: (id) => `${PATH}/aemi/dashboard/customers/company/reference-type${getById(id)}`,
      allCustomers: `${PATH}/aemi/dashboard/reports/reconciliation-statements/fetch-all-customers`,
      alUsers: `${PATH}/aemi/dashboard/customers/all`,
      downloadReport: `${PATH}/aemi/dashboard/reports/reconciliation-statements/download`,
      downloadWalletsReport: `${PATH}/aemi/dashboard/reports/wallet-logs/multiple-download`,
      downloadWalletReport: (id) => `${PATH}/aemi/dashboard/reports/wallet-logs${getById(id)}/download`,
      unsignedTransaction: (id) => `${PATH}/aemi/dashboard/customers/company/unsigned-transactions${getById(id)}`,
      signaturesTransaction: (id) => `${PATH}/aemi/dashboard/customers/company/signatures${getById(id)}`,
      logs: (id) => `${PATH}/aemi/dashboard/customers/company${getById(id)}/logs`,
      walletLogs: `${PATH}/aemi/dashboard/reports/wallet-logs`,
      transactionLogs: `${PATH}/aemi/dashboard/reports/transaction-logs`,
      walletManagers: `${PATH}/aemi/dashboard/reports/wallet-managers`,
      walletLog: (id) => `${PATH}/aemi/dashboard/reports/wallet-logs${getById(id)}`,
      riskLevelReport: `${PATH}/aemi/dashboard/reports/risk-level`,
      minSignatures: (id) => `${PATH}/aemi/dashboard/customers/company${getById(id)}/min-signatures`,
      switchSignature: (id) => `${PATH}/aemi/dashboard/customers${getById(id)}/switch-signature`,
      unsignedTransactions: (id) => `${PATH}/aemi/dashboard/customers/company${getById(id)}/unsigned-transactions`,
      unsignedTransactionsExport: (id) =>
        `${PATH}/aemi/dashboard/customers/company${getById(id)}/unsigned-transactions/export`,
      tfaEnabled: (id) => `${PATH}/aemi/dashboard/customers${getById(id)}/tfa-enabled`,
      phoneTfaUsing: (id) => `${PATH}/aemi/dashboard/customers${getById(id)}/phone-tfa-using`,
      automaticFees: (id) => `${PATH}/aemi/dashboard/customers${getById(id)}/automatic-fees`,
      co_approval: (id) => `${PATH}/aemi/dashboard/customers${getById(id)}/co-approval`,
      third_party_transactions: (id) => `${PATH}/aemi/dashboard/customers${getById(id)}/third-party-transactions`,
      switchFxAccess: (id) => `${PATH}/aemi/dashboard/customers${getById(id)}/switch-fx-access`,
      messages: (id) => `${PATH}/aemi/dashboard/information-request/messages${getById(id)}`,
      messages_info: (id) => `${PATH}/aemi/dashboard/information-request/messages-info${getById(id)}`,
      message: () => `${PATH}/aemi/dashboard/information-request/message`,
      changeStatus: (id) => `${PATH}/aemi/dashboard/information-request/change-status${getById(id)}`,
      unreadMessages: () => `${PATH}/aemi/dashboard/information-request/new-messages`,
      transactionsFx: `${PATH}/aemi/dashboard/reports/fx-transactions`,
      tariffReport: `${PATH}/aemi/dashboard/reports/tariffs`,
    },
  },
  notifications: {
    aemi: {
      list: `${PATH}/aemi/dashboard/notifications`,
      subscriptions: `${PATH}/aemi/dashboard/notifications/subscriptions`,
      subscribe: (id) => `${PATH}/aemi/dashboard/notifications/subscribe${getById(id)}`,
      unsubscribe: (id) => `${PATH}/aemi/dashboard/notifications/unsubscribe${getById(id)}`,
      subscribeAll: `${PATH}/aemi/dashboard/notifications/subscribe-to-all-notifications`,
      unsubscribeFromAll: `${PATH}/aemi/dashboard/notifications/unsubscribe-from-all-notifications`,
      apiNotificationMarkRead: (id) => `${PATH}/aemi/dashboard/notifications/api-notification-mark-read${getById(id)}`,
      apiNotification: (id) => `${PATH}/aemi/dashboard/notifications/api-notification${getById(id)}`,
      apiNotificationDelete: (id) => `${PATH}/aemi/dashboard/notifications/delete-api-notification${getById(id)}`,
    },
  },
  kyb: {
    companies_house: {
      search: (title = '') => `${PATH}/kyb/ch/company/search/${title}`,
      info: (company_id, parameter = '') => `${PATH}/kyb/ch/company/${company_id}/${parameter}`,
    },
    credit_safe: {
      basic: (company_id) => `${PATH}/kyb/cs/company/basic/${company_id}`,
      full: (company_id) => `${PATH}/kyb/cs/company/full/${company_id}`,
    },
    report: (business_id) => `${PATH}/aemi/dashboard/report/business/${business_id}`,
  },
  kyc: {
    jumio: {
      verification: `${PATH}/kyc/jumio/createVerification/`,
      verificationPersonal: (profile_id) => `${PATH}/kyc/jumio/createVerification/personal/${profile_id}`,
      update: `${PATH}/kyc/jumio/verification/`,
      getImages: (profile_id) => `${PATH}/kyc/jumio/scan${getById(profile_id)}`,
    },
    sumsub: {
      progress: `${MAGMA}/kyc/sumsub/verification/`,
      verification: `${MAGMA}/kyc/sumsub/createVerification/`,
      verificationPersonal: (profile_id) => `${PATH}/kyc/sumsub/createVerification/personal/${profile_id}`,
      result: `${PATH}/kyc/sumsub/verificationResult/`,
      resendVerification: (profile_id) => `${PATH}/aemi/dashboard/report/personal/${profile_id}/invitation`,
    },
    report: (person_id) => `${PATH}/aemi/dashboard/report/personal/${person_id}`,
  },
  case_management: {
    cases: (id = '') => `${PATH}/case-management/cases${getById(id)}`,
    export: (id = '') => `${PATH}/case-management/cases/export${getById(id)}`,
    statuses: () => `${PATH}/case-management/cases/getStatuses`,
    tags: `${PATH}/case-management/tags`,
    comments: (id) => `${PATH}/case-management/cases/${id}/comments`,
    history: (id) => `${PATH}/case-management/cases/${id}/report`,
    complyAdvantage: (id = '') => `${PATH}/kyc/ca/searches/${id}/entities`,
    toggleSubscription: (id) => `${PATH}/case-management/cases/toggle-subscription${getById(id)}`,
    returnToAdjustment: (id) => `${PATH}/case-management/cases/${id}/return-adjustment`,
  },
  banking: {
    modulr: {
      status: `${PATH}/banking/modulr/customers/status`,
      create: `${PATH}/banking/modulr/customers`,
    },
    bank_institutions: (id = '') => `${PATH}/banking/aemi/bank-institutions${getById(id)}`,
    transfer_aml_report: (type, id = '') => `${PATH}/banking/${type}/transfer-aml-report${getById(id)}`,
    bank_export: `${PATH}/aemi/dashboard/banking/treasury/transactions/export-bank/file`,
    bank_export_list: `${PATH}/aemi/dashboard/banking/treasury/transactions/export-bank/list`,
    bank_institutions_for_transaction: (id = '') =>
      `${PATH}/aemi/dashboard/banking/treasury/transactions/bank-institutions${getById(id)}`,
    available_banks_for_customer: (id) => `${PATH}/aemi/dashboard/customers/${id}/profile-bank-institutions`,
    bank_institutions_export: `${PATH}/banking/aemi/bank-institutions/export`,
    import_managers: `${PATH}/banking/aemi/import-managers`,
    bank_institution_bulk_update: `${PATH}/banking/aemi/bank-institutions/bulk-update`,
    setBank: (id = '') => `${PATH}/aemi/dashboard/banking/treasury/transactions${getById(id)}`,
    setBankBulkAssign: `${PATH}/aemi/dashboard/banking/treasury/transactions/bulk-assign`,
    treasuryTransfer: (id = '') => `${PATH}/aemi/dashboard/banking/treasury/transfer${getById(id)}`,
    treasuryTransferApprove: (id = '') => `${PATH}/aemi/dashboard/banking/treasury/transfer${getById(id)}/approve`,
    treasuryTransferDecline: (id = '') => `${PATH}/aemi/dashboard/banking/treasury/transfer${getById(id)}/decline`,
    treasuryMadeTransfer: (id = '') => `${PATH}/aemi/dashboard/banking/treasury/transfer${getById(id)}/mark-as-made`,
    treasuryTransferBulkApprove: `${PATH}/aemi/dashboard/banking/treasury/transfer/bulk-approve`,
    treasuryTransferBulkDecline: `${PATH}/aemi/dashboard/banking/treasury/transfer/bulk-decline`,
    treasuryMadeTransfers: `${PATH}/aemi/dashboard/banking/treasury/transfer/bulk-mark-as-made`,
    treasuryTransferFinalize: (id = '') => `${PATH}/aemi/dashboard/banking/treasury/transfer${getById(id)}/finalize`,
    payment_codes: `${PATH}/banking/payment-codes`,
    payment_codes_export: `${PATH}/banking/payment-codes/export`,
    payment_code: (id = '') => `${PATH}/banking/aemi/payment-codes${getById(id)}`,
    transactionsExport: `${PATH}/aemi/dashboard/banking/clients/transactions/export`,
    transactions: `${PATH}/aemi/dashboard/banking/clients/transactions`,
    client_transactions: `${PATH}/aemi/dashboard/banking/clients/transactions/clients`,
    co_approvals: `${PATH}/aemi/dashboard/banking/co-approvals`,
    co_postcontrol: `${PATH}/aemi/dashboard/banking/co/post-control`,
    co_postcontrol_approve: (id = '') => `${PATH}/aemi/dashboard/banking/co/post-control${getById(id)}/approve`,
    unclarified_funds: `${PATH}/aemi/dashboard/banking/unclarified-funds`,
    configurations: `${PATH}/aemi/dashboard/configurations`,
    configurationTabs: `${PATH}/aemi/dashboard/configurations/tabs`,
    categories: `${PATH}/aemi/dashboard/banking/transactional-documents/options/categories`,
    criteria: `${PATH}/aemi/dashboard/banking/transactional-documents/options/criteria`,
    updateTransactionDetails: (id = '') =>
      `${PATH}/aemi/dashboard/banking/transactional-documents${getById(id)}/update-details`,
    auditorAccessPeriod: (id = '') => `${PATH}/users/aemi/auditor-workspace${getById(id)}`,
    updateDocuments: (id = '') =>
      `${PATH}/aemi/dashboard/banking/transactional-documents${getById(id)}/store-documents`,
    treasuryTransactions: (id = '') => `${PATH}/aemi/dashboard/banking/treasury/transactions${getById(id)}`,
    card_indexes: (id = '') => `${PATH}/aemi/dashboard/banking/treasury/card-indexes${getById(id)}`,
    transactionDocuments: (id = '') => `${PATH}/aemi/dashboard/banking/transactional-documents${getById(id)}`,
    approveTransactionDocuments: (id = '') =>
      `${PATH}/aemi/dashboard/banking/transactional-documents${getById(id)}/approve`,
    signTransactionDocuments: (id = '') => `${PATH}/aemi/dashboard/banking/transactional-documents${getById(id)}/sign`,
    rejectTransactionDocuments: (id = '') =>
      `${PATH}/aemi/dashboard/banking/transactional-documents${getById(id)}/reject`,
    approveOrder: (id = '') => `${PATH}/aemi/dashboard/banking/treasury/client-requests${getById(id)}/approve`,
    updateOrder: (id = '') => `${PATH}/aemi/dashboard/banking/treasury/client-requests${getById(id)}/update`,
    cancelOrder: (id = '') => `${PATH}/aemi/dashboard/banking/treasury/client-requests${getById(id)}/reject`,
    treasuryPaymentOrders: (id = '') => `${PATH}/aemi/dashboard/banking/treasury/client-requests${getById(id)}`,
    confirmationsTransactions: (id = '') => `${PATH}/aemi/dashboard/banking/treasury/confirmations${getById(id)}`,
    archiveTransactions: (id = '') => `${PATH}/aemi/dashboard/banking/treasury/confirmations${getById(id)}`,
    amlTransactions: (id = '') => `${PATH}/aemi/dashboard/banking/aml/transactions${getById(id)}`,
    amlManualVerification: (id = '') =>
      `${PATH}/aemi/dashboard/banking/treasury/transactions/manual-verification${getById(id)}`,
    amlManualVerificationThirdParty: (id) =>
      `${PATH}/aemi/dashboard/banking/treasury/transactions/manual-verification/${id}/third-party`,
    amlManualVerificationPayee: (id) =>
      `${PATH}/aemi/dashboard/banking/treasury/transactions/manual-verification/${id}/payee`,
    postControl: `${PATH}/aemi/dashboard/banking/post-control`,
    postControlTransactionsApprove: (id = '') =>
      `${PATH}/aemi/dashboard/banking/post-control/transactions${getById(id)}/approve`,
    postControlTransactionsBulkApprove: `${PATH}/aemi/dashboard/banking/post-control/transactions/bulk-approve`,
    transactionToReview: (id = '') => `${PATH}/aemi/dashboard/banking/post-control/transactions${getById(id)}/reject`,
    transactionsBulkSignature: `${PATH}/banking/company/transactions/bulk-signature`,
    documentsPostControlTransaction: (id = '') =>
      `${PATH}/aemi/dashboard/banking/post-control/transactions${getById(id)}/store-documents`,
    statusTransaction: (id = '') => `${PATH}/aemi/dashboard/banking/clients/transactions${getById(id)}`,
    approveAmlTransaction: (id = '') => `${PATH}/aemi/dashboard/banking/aml/transactions${getById(id)}/approve`,
    approveManualTransaction: (id = '') =>
      `${PATH}/aemi/dashboard/banking/treasury/transactions/manual-verification${getById(id)}/approve`,
    advancedAmlTransaction: (id = '') =>
      `${PATH}/aemi/dashboard/banking/aml/transactions${getById(id)}/advanced-payment`,
    declineAmlTransaction: (id = '') => `${PATH}/aemi/dashboard/banking/aml/transactions${getById(id)}/reject`,
    returnAdjustmentAmlTransaction: (id = '') =>
      `${PATH}/aemi/dashboard/banking/aml/transactions${getById(id)}/return-adjustment`,
    documentsAmlTransaction: (id = '') =>
      `${PATH}/aemi/dashboard/banking/aml/transactions${getById(id)}/store-documents`,
    documentsConfirmationsTransaction: (id = '') =>
      `${PATH}/aemi/dashboard/banking/treasury/confirmations${getById(id)}/upload-swift-documents`,
    paymentStatusColorAmlTransaction: (id = '') =>
      `${PATH}/aemi/dashboard/banking/aml/transactions${getById(id)}/payment-label-color`,
    transactionalDocuments: (id = '') => `${PATH}/aemi/dashboard/banking/transactional-documents${getById(id)}`,
    completeTransaction: (id = '') => `${PATH}/aemi/dashboard/payments${getById(id)}/complete`,
    transfer_confirmation: (type, id) => `${PATH}/banking/${type}/transfer-confirmation${getById(id)}`,
    virtual_wallet_create: (type) => `${PATH}/${type}/dashboard/wallet`,
    clear_junction_create: `${PATH}/banking/clearjunction/accounts`,
    edit_wallet: (type) => `${PATH}/${type}/dashboard/banking/clients/wallets/update`,
    automatic_fee_transaction: (transaction_id, fee_type) =>
      `${PATH}/aemi/dashboard/banking/clients/wallets/manual-automatic-fee/description?transaction_id=${transaction_id}&fee_type=${fee_type}`,
    automatic_fee: (type) => `${PATH}/${type}/dashboard/banking/clients/wallets/manual-automatic-fee`,
    list_fee_values: (type) => `${PATH}/${type}/dashboard/banking/clients/wallets/manual-automatic-fee/values`,
    automatic_fees: (type, id) => `${PATH}/banking/${type}/tariff-plans${getById(id)}/automatic-commissions`,
    download_client_details: (type, id) =>
      `${PATH}/${type}/dashboard/banking/clients/wallets${getById(id)}/documents/account-confirmation`,
    limited_partner_interest: (type) => `${PATH}/${type}/dashboard/banking/clients/wallets/interest-list`,
    statuses_list: (type) => `${PATH}/${type}/dashboard/banking/clients/wallets/statuses-list`,
    set_status: (type, id) => `${PATH}/${type}/dashboard/banking/clients/wallets${getById(id)}/set-status`,
    wallets: (type) => `${PATH}/${type}/dashboard/banking/clients/wallets`,
    wallets_export: (type) => `${PATH}/${type}/dashboard/banking/clients/wallets/export`,
    signature: (id) => `${PATH}/banking/company/transactions${getById(id)}/signatures`,
    wallet_update_info: (type, id) => `${PATH}/${type}/dashboard/banking/clients/wallets${getById(id)}/update-info`,
    update_currencies: (type, id) =>
      `${PATH}/${type}/dashboard/banking/clients/wallets${getById(id)}/update-currencies`,
    clientWallets: (type) => `${PATH}/banking/${type}/client-wallets`,
    aemi: {
      exchanges: (id = '') => `${PATH}/foreign-exchange/aemi${getById(id)}`,
      get_rate: (id = '') => `${PATH}/foreign-exchange/aemi/actual-rates${getById(id)}`,
      balkUpdate: `${PATH}/foreign-exchange/aemi/bulk-update`,
      co_approval_balk: `${PATH}/aemi/dashboard/banking/co-approvals/bulk-update`,
      co_approval: `${PATH}/aemi/dashboard/banking/co-approvals`,
      aemiCompany: `${PATH}/foreign-exchange/aemi/own/profiles`,
      aemiOwnCompany: `${PATH}/aemi/dashboard/banking/clients/transactions/own-company-wallets`,
      aemiTreasury: `${PATH}/aemi/dashboard/banking/clients/own-company-wallets`,
      completeClientTransaction: (id = '') =>
        `${PATH}/aemi/dashboard/banking/clients/transactions/clients${getById(id)}/finalize`,
      completeDuplicateClientTransaction: (id = '') =>
        `${PATH}/aemi/dashboard/payments${getById(id)}/complete-duplicate`,
      markupsInfo: (id = '') => `${PATH}/foreign-exchange/aemi/markups${getById(id)}/info`,
      getRates: `${PATH}/foreign-exchange/aemi/markups/rates`,
      markups: (id = '') => `${PATH}/foreign-exchange/aemi/markups${getById(id)}`,
      exportMarkups: (id = '') => `${PATH}/foreign-exchange/aemi/markups${getById(id)}/export`,
      importMarkups: (id = '') => `${PATH}/foreign-exchange/aemi/markups${getById(id)}/import`,
      currencies: () => `${getDashboardRoute()}/banking/currencies`,
      beneficiaries: (id = '', type = '') => `${PATH}/${type}/dashboard/beneficiaries${getById(id)}`,
      beneficiariesApproved: (id = '', type = '') => `${PATH}/${type}/dashboard${getById(id)}/beneficiaries/approved`,
      beneficiariesAvailable: (id = '', type = '') => `${PATH}/${type}/dashboard${getById(id)}/beneficiaries/available`,
      beneficiariesGetAccount: (id = '', type = '') => `${PATH}/${type}/dashboard/beneficiaries${getById(id)}/accounts`,
      currenciesAll: () => `${getDashboardRoute()}/banking/currencies-all`,
      colorsAll: (id = '') => `${getDashboardRoute()}/markets/transaction-colors${getById(id)}`,
      statement_payments: () => `${getDashboardRoute()}/banking/clients/statement`,
      balance_report: () => `${getDashboardRoute()}/reports/wallet-statements`,
      treasury_transfer_report: () => `${getDashboardRoute()}/reports/liquidity-reports`,
      client_summary_report: () => `${getDashboardRoute()}/reports/client-summary`,
    },
    client: {
      draft_transactions: (type, id) => `${PATH}/banking/${type}/draft-transactions${getById(id)}`,
      cancel_transactions: (type, id) => `${PATH}/banking/${type}/transactions${getById(id)}/cancel`,
      need_attention: (id, type) => `${PATH}/banking/${type}/need-attention-transactions${getById(id)}`,
      aml_requests: (type, id) => `${PATH}/banking/${type}/aml-requests${getById(id)}`,
      complete_draft_transactions: (type, id) => `${PATH}/banking/${type}/draft-transactions${getById(id)}/complete`,
      third_party_transactions: (type) => `${PATH}/banking/${type}/transactions/third-party`,
      currencyPair: () => `${PATH}/foreign-exchange/currency-pairs`,
      calculation: () => `${PATH}/foreign-exchange/fix-rate`,
      calculationReport: () => `${PATH}/foreign-exchange/fix-rate/report`,
      aemiCalculation: () => `${PATH}/foreign-exchange/aemi/own/fix-rate`,
      statistics: () => `${PATH}/foreign-exchange/aemi/statistics`,
      exchanges: () => `${PATH}/foreign-exchange`,
      aemiExchanges: (id) => `${PATH}/foreign-exchange/aemi/own${getById(id)}`,
      currencies: (type) => `${MAGMA}/banking/${type}/currencies`,
      third_person: (type, id) => `${PATH}/banking/${type}/third-party${getById(id)}`,
      changeThirdParty: (type, transaction_id) => `${PATH}/banking/${type}/transactions/${transaction_id}/third-party`,
      generate_reference: (type) => `${PATH}/banking/${type}/transactions/generate-reference`,
      generate_description: (type) => `${PATH}/banking/${type}/transactions/generate-description`,
      orders: (type) => `${PATH}/banking/${type}/client-requests`,
      feePrices: (type, id) => `${PATH}/banking/${type}/client-requests/fee-prices${getById(id)}`,
      paymentTypes: () => `${PATH}/banking/transactions/payment-execution-types`,
      paymentChannelTypes: () => `${PATH}/banking/transactions/payment-channel-types`,
      beneficiaries: (id = '', type = '') => `${PATH}/banking/${type}/beneficiaries${getById(id)}`,
      internalBeneficiaries: (id = '', type = '') => `${PATH}/banking/${type}/internal-beneficiary${getById(id)}`,
      beneficiariesGetAccount: (id = '', type = '') => `${PATH}/banking/${type}/beneficiaries${getById(id)}/accounts`,
      currenciesAll: () => `${PATH}/banking/currencies-all`,
      statement_payments: (type) => `${PATH}/banking/${type}/statement`,
    },
    markets: (id) => `${PATH}/aemi/dashboard/markets${getById(id)}`,
    available_markets: (id) => `${PATH}/users/aemi/team${getById(id)}/available-markets`,
    customer_groups: (id) => `${PATH}/aemi/dashboard/customer-groups${getById(id)}`,
    market_groups: (id) => `${PATH}/aemi/dashboard/markets/groups${getById(id)}`,
    market_groups_assign_to_team: `${PATH}/aemi/dashboard/markets/groups/assign-to-aemi`,
    beneficiaries_approved: (type = '') => `${PATH}/banking/${type}/beneficiaries-approved`,
    beneficiaries_available: (type = '') => `${PATH}/banking/${type}/beneficiaries-available`,
    beneficiariesReactivate: (id = '', type = '') => `${PATH}/banking/${type}/beneficiary-reactivate${getById(id)}`,
    beneficiariesDeleteAccount: (id = '') => `${PATH}/banking/beneficiaries/accounts${getById(id)}`,
    beneficiariesAccount: (id = '', type = '') => `${PATH}/banking/${type}/beneficiaries/accounts${getById(id)}`,
    beneficiariesGetActiveAccount: (id = '', type = '') =>
      `${PATH}/banking/${type}/beneficiaries${getById(id)}/active-accounts`,
    beneficiariesGetAvailableAccount: (id = '', type = '') =>
      `${PATH}/banking/${type}/beneficiaries${getById(id)}/available-accounts`,
    checkAccountIban: (type, iban) => `${PATH}/banking/${type}/check/${iban}`,
    bic: `${PATH}/banking/bic/`,
    checkInternalAccountIban: (type, iban) => `${PATH}/banking/${type}/internal-beneficiary/${iban}`,
    accounts: (id = '', type = '') => `${PATH}/banking/${type}/wallets${getById(id)}`,
    tariff_plans_markups: (id = '', type = '') => `${PATH}/banking/${type}/tariff-plans/markups${getById(id)}`,
    accountsForThirdParty: (id = '', type = '') => `${PATH}/banking/${type}/wallets/third-party${getById(id)}`,
    payments: (id = '', type = '') => `${PATH}/banking/${type}/transactions${getById(id)}`,
    transactionsForClientRequests: (type = '') => `${PATH}/banking/${type}/transactions/for-client-requests`,
    adjustment: (id = '', type = '') => `${PATH}/banking/${type}/transactions${getById(id)}/adjustment`,
    calc_fee: (type) => `${PATH}/banking/${type}/transactions/commission`,
    pricing_plans: (userType, id = '') => `${PATH}/banking/${userType}/pricing-plans${getById(id)}`,
    pricing_plan_positions: (userType) => `${PATH}/banking/${userType}/pricing-plan-positions`,
    pricing_plan_set_default: (userType, id = '') => `${PATH}/banking/${userType}/pricing-plan-set-default/${id}`,
    pricing_plan_by_vendor: (userType) => `${PATH}/banking/${userType}/pricing-plan-by-vendor`,
    pricing_plan_assign_to_customer: (userType) => `${PATH}/banking/${userType}/pricing-plan-assign-to-customer`,
    tariff_commission: (userType) => `${PATH}/banking/${userType}/tariff-plans/create`,
    tariff_options: (userType) => `${PATH}/banking/${userType}/tariff-plans/options`,
    set_tariff_plan: (id) => `${PATH}/aemi/dashboard/banking/clients/wallets${getById(id)}/set-tariff-plan`,
    change_tariff_plan: (id) => `${PATH}/aemi/dashboard/banking/clients/wallets${getById(id)}/change-tariff-plan`,
    tariff_plans: (userType, id = '') => `${PATH}/banking/${userType}/tariff-plans${getById(id)}`,
    wallets_vacations: (userType, id = '') => `${PATH}/banking/${userType}/tariff-plan-vacations/wallets${getById(id)}`,
    tariff_plan_vacations: (userType, id) => `${PATH}/banking/${userType}/tariff-plan-vacations${getById(id)}`,
    tariff_plans_export: (userType, id = '') => `${PATH}/banking/${userType}/tariff-plans/export${getById(id)}`,
    tariff_plans_manual: (userType, id = '') =>
      `${PATH}/banking/${userType}/tariff-plans${getById(id)}/manual-commissions`,
    active_currencies: () => `${getDashboardRoute()}/banking/currencies`,
    vault_currencies: () => `${getDashboardRoute()}/banking/currencies-vault`,
    currencies_vault: (network) => `${getDashboardRoute()}/banking/currencies-vault?network=${network}`,
    active_vendors: () => `${getDashboardRoute()}/banking/vendors`,
    transactionComments: `${PATH}/aemi/dashboard/banking/transaction-comments/`,
    transactionComment: (id) => `${PATH}/aemi/dashboard/banking/transaction-comments/${id}`,
    commentsAvailableSource: `${PATH}/aemi/dashboard/banking/transaction-comments/available-sources`,
    hideCommentsSource: (source) => `${PATH}/aemi/dashboard/banking/transaction-comments/hide/${source}`,
    showCommentsSource: (source) => `${PATH}/aemi/dashboard/banking/transaction-comments/show/${source}`,
    amlRequests: (id = '') => `${PATH}/aemi/dashboard/banking/aml/aml-requests${getById(id)}`,
    amlRequestsAction: (id, action) => `${PATH}/aemi/dashboard/banking/aml/aml-requests/${id}/${action}`,
  },
  customers: {
    overview: (type = '') => `${getDashboardRoute()}/customers/${type}`,
    export: (type = '') => `${getDashboardRoute()}/customers/${type}/export`,
    customerInfo: (id = '') => `${getDashboardRoute()}/customers${getById(id)}`,
    updateCompany: (id = '') => `${getDashboardRoute()}/customers/company${getById(id)}`,
    updateIndividual: (id = '') => `${getDashboardRoute()}/customers/individual${getById(id)}`,
    updateCustomerDescription: (id = '') => `${getDashboardRoute()}/customers/description${getById(id)}`,
    partners: (id = '') => `${getDashboardRoute()}/customers/partners${getById(id)}`,
    directors: (id = '') => `${getDashboardRoute()}/customers/directors${getById(id)}`,
    changeMainDirector: (id) => `${PATH}/aemi/dashboard/customers/directors${getById(id)}/assign-as-business-profile`,
    verificationRequired: (id) => `${PATH}/aemi/dashboard/customers${getById(id)}/verification-required`,
    shareholdersPersonal: (id = '') => `${getDashboardRoute()}/customers/shareholders/personal${getById(id)}`,
    shareholdersBusiness: (id = '') => `${getDashboardRoute()}/customers/shareholders/business${getById(id)}`,
    updateAgreements: (id = '', type = '') => `${getDashboardRoute()}/customers/${type}/agreements${getById(id)}`,
    updateBusinessActivity: (id = '', type = '') =>
      `${getDashboardRoute()}/customers/${type}/business-activity${getById(id)}`,
    onboarding: () => `${getDashboardRoute()}/onboarding/status`,
    status: () => `${getDashboardRoute()}/onboarding/status`,
    block: (id) => `${getDashboardRoute()}/customers/block${getById(id)}`,
    unblock: (id) => `${getDashboardRoute()}/customers/unblock${getById(id)}`,
    userLevel: (id) => `${getDashboardRoute()}/customers/company/user-level${getById(id)}`,
    userLevelClient: (id) => `${PATH_USERS}${getById(id)}/user-levels`,
    userLevels: () => `${getDashboardRoute()}/customers/company/user-levels`,
    riskLevel: () => `${getDashboardRoute()}/customers/company/risk-level`,
    userRiskLevel: (id) => `${getDashboardRoute()}/customers/company/risk-level${getById(id)}`,
    userBlockColours: (id) => `${getDashboardRoute()}/customers/${id}/block-colours`,
    userBlockBanks: (id) => `${getDashboardRoute()}/customers/${id}/block-banks`,
  },
  team: `${PATH}/users/aemi/team`,
  team_user: (id = '') => `${PATH}/users/aemi/team${getById(id)}`,
  team_permissions: (id = '') => `${PATH}/users/aemi/team/permissions${getById(id)}`,
  assign_permissions: (id = '') => `${PATH}/users/aemi${getById(id)}/permissions`,
  staffManualFinish: `${MAGMA}/users/company/staff/manually-finish`,
  deletedTeamUsers: `${PATH}/users/aemi/deleted`,
  roles: `${PATH}/users/aemi/roles`,
  role: (id = '') => `${PATH}/users/aemi/roles${getById(id)}`,
  deleteAemi: (id = '') => `${PATH}/users/aemi/profile/delete${getById(id)}`,
  resendLinkAemi: (id = '') => `${PATH}/users/aemi/team/resend-aemi-activation-link${getById(id)}`,
  rolePermissions: (id = '') => `${PATH}/users/aemi/roles${getById(id)}/permissions`,
  rolePermissionsBulk: (id = '') => `${PATH}/users/aemi/roles${getById(id)}/permissions/bulk`,
  rolePermission: (id = '', permId = '') => `${PATH}/users/aemi/roles${getById(id)}/permissions${getById(permId)}`,
  roleCreate: (id = '') => `${PATH}/users/aemi/roles${getById(id)}`,
  permissions: `${PATH}/users/aemi/permissions`,
  permissionGroups: (id = '') => `${PATH}/users/aemi/permission-groups${getById(id)}`,
  permissionGroupsAttach: (id = '') => `${PATH}/users/aemi/permission-groups${getById(id)}/permissions/attach`,
  permissionGroupsDetach: (id = '') => `${PATH}/users/aemi/permission-groups${getById(id)}/permissions/detach`,
  configurations: `${PATH}/aemi/dashboard/configurations`,
  get_users: `${PATH}/aemi/dashboard/users`,
  filemanager: {
    registration_documents_temp: (id = '') => `${MAGMA}/filemanager/documents/registration${getById(id)}`,
    client_staff_documents_temp: (id = '') => `${PATH}/filemanager/documents/staff${getById(id)}`,
    identificationDocuments: (id = '') => `${PATH}/filemanager/documents/identification${getById(id)}`,
    getAllCustomerFiles: (id = '') => `${PATH}/filemanager/documents/business${getById(id)}`,
    aemiDocuments: (id = '') => `${PATH}/aemi/filemanager/document/upload${getById(id)}`,
    amlDocuments: (id = '') => `${PATH}/filemanager/documents/transaction${getById(id)}`,
    confirmationsDocuments: (id = '') => `${PATH}/filemanager/swift-document/transaction${getById(id)}`,
    deleteAemiDocuments: (id = '') => `${PATH}/aemi/filemanager/document${getById(id)}`,
    shareholderDocuments: (id = '') => `${PATH}/filemanager/documents/shareholder${getById(id)}`,
    caseDocuments: (id = '') => `${PATH}/filemanager/documents/case${getById(id)}`,
    download: (id = '') => `${PATH}/filemanager/documents/download${getById(id)}`,
    downloadVerifyCounterparty: (id = '') => `${PATH}/filemanager/documents/verify-counterparty/download${getById(id)}`,
    transaction: (id = '') => `${PATH}/filemanager/documents/transaction${getById(id)}`,
    transactionAmlRequest: (id = '') => `${PATH}/filemanager/documents/transaction-aml-requests${getById(id)}`,
    request: (id = '') => `${PATH}/filemanager/documents/transaction-aml-requests${getById(id)}`,
    third_party: (id = '') => `${PATH}/filemanager/documents/third-party${getById(id)}`,
    orders: (id = '') => `${PATH}/filemanager/documents/client-requests${getById(id)}`,
    downloadByUser: (id = '', type = '') => `${PATH}/filemanager/documents${getById(type)}/download${getById(id)}`,
    upload: (id = '') => `${PATH}/aemi/filemanager/document/upload${getById(id)}`,
    deleteTemp: (id = '') => `${PATH}/aemi/filemanager/document/upload/temp${getById(id)}`,
    delete: (id = '') => `${PATH}/aemi/filemanager/documents${getById(id)}`,
    catalogs: (id = '') => `${PATH}/aemi/filemanager/documents/catalogs${getById(id)}`,
    infoRequestMessageDocuments: (type, id = '') =>
      `${PATH}/filemanager/documents/information-request/${type}${getById(id)}`,
    downloadArchiveForAmlRequest: (id = '') => `${PATH}/aemi/dashboard/banking/co/aml-requests/${id}/download`,
    aemi: {
      documents: {
        directoryType: (id = '') => `${PATH}/aemi/filemanager/documents/directory-type${getById(id)}`,
        exportDirectoryType: `${PATH}/aemi/filemanager/documents/validity/export`,
        validity: (id = '') => `${PATH}/aemi/filemanager/documents/validity${getById(id)}`,
        jurisdictions: () => `${PATH}/aemi/dashboard/jurisdictions`,
        otherDocuments: () => `${PATH}/aemi/dashboard/customers/backoffice/other-documents`,
        forwardToDocumentDirectoryType: () => `${PATH}/aemi/filemanager/document/forward-to-document-directory-type`,
        updateExpirationDate: () => `${PATH}/aemi/filemanager/document/update-expiration-date`,
      },
    },
    verifyBeneficiaryDocuments: (id = '') => `${PATH}/filemanager/documents/verify-counterparty/temp${getById(id)}`,
    uploadClientRequestDoc: `${PATH}/filemanager/documents/paid-services/client-request/temp`,
    viewClientRequestDoc: (id = '') => `${PATH}/filemanager/documents/paid-services/client-request/preview/${id}`,
    downloadClientRequestDoc: (id = '') => `${PATH}/filemanager/documents/paid-services/client-request/download/${id}`,
    deleteClientRequestDoc: (id = '') => `${PATH}/filemanager/documents/paid-services/client-request/temp/${id}`,
  },
  geo: {
    postalCode: (countryCode) => `${PATH}/geo/country?filter[code]=${countryCode}`,
  },
  statistics: {
    vendorUsage: (userType = 'aemi') => `${PATH}/${userType}/dashboard/statistics/vendors`,
  },
};
